import { createEntityAdapter } from '@reduxjs/toolkit'

import { soyshareApi } from '../../../../../services/api'
import { savingMessagesNotification } from '../helpers/messages'

const adapter = createEntityAdapter({
  selectId: ({ fieldRelationshipId, mainOptionId }) => `${fieldRelationshipId}_${mainOptionId}`
})

const initialState = adapter.getInitialState()

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getSelectOptionRelationships: build.query({
      query: ({ fieldId }) => ({ url: `form-fields/relationships/select-options/field/${fieldId}` }),
      providesTags: ['select-option-relationships'],
      transformResponse: (response) => adapter.setAll(initialState, response)
    }),

    createSelectOptionRelationship: build.mutation({
      query: ({ payload }) => ({
        url: `form-fields/relationships/select-options`,
        method: 'POST',
        body: payload
      }),
      onQueryStarted: async ({ payload, fieldId }, { dispatch, queryFulfilled }) => {
        savingMessagesNotification.saving()
        const patchResult = dispatch(
          api.util.updateQueryData('getSelectOptionRelationships', { fieldId }, (draft) => {
            adapter.upsertOne(draft, {
              id: `${payload.fieldRelationshipId}_${payload.mainOptionId}`,
              ...payload
            })
          })
        )
        queryFulfilled.then(() => savingMessagesNotification.success()).catch(patchResult.undo)
      }
    }),

    removeSelectOptionRelationship: build.mutation({
      query: ({ payload }) => ({
        url: `form-fields/relationships/select-options`,
        method: 'DELETE',
        body: payload
      }),
      onQueryStarted: async ({ payload, fieldId }, { dispatch, queryFulfilled }) => {
        savingMessagesNotification.saving()
        const patchResult = dispatch(
          api.util.updateQueryData('getSelectOptionRelationships', { fieldId }, (draft) => {
            adapter.removeOne(draft, `${payload.fieldRelationshipId}_${payload.mainOptionId}`)
          })
        )
        queryFulfilled.then(() => savingMessagesNotification.success()).catch(patchResult.undo)
      }
    })
  })
})

export const {
  useGetSelectOptionRelationshipsQuery,
  useCreateSelectOptionRelationshipMutation,
  useRemoveSelectOptionRelationshipMutation
} = api
